module.exports = {
	"ETH": "Ethiopia",
	"BOL": "Bolivia",
	"NOR": "Norway",
	"HRV": "Croatia",
	"COD": "DR Congo",
	"ZAF": "South Africa",
	"VNM": "Vietnam",
	"BRN": "Brunei",
	"CZE": "Czechia",
	"BDI": "Burundi",
	"BHR": "Bahrain",
	"LKA": "Sri Lanka",
	"ECU": "Ecuador",
	"JPN": "Japan",
	"SVK": "Slovakia",
	"MYS": "Malaysia",
	"KOR": "South Korea",
	"AZE": "Azerbaijan",
	"IRL": "Ireland",
	"JAM": "Jamaica",
	"SYR": "Syria",
	"NGA": "Nigeria",
	"POL": "Poland",
	"URY": "Uruguay",
	"SWE": "Sweden",
	"KAZ": "Kazakhstan",
	"HND": "Honduras",
	"CRI": "Costa Rica",
	"GTM": "Guatemala",
	"GRC": "Greece",
	"DZA": "Algeria",
	"ARM": "Armenia",
	"ALB": "Albania",
	"MOZ": "Mozambique",
	"NIC": "Nicaragua",
	"OMN": "Oman",
	"ISR": "Israel",
	"KHM": "Cambodia",
	"MMR": "Myanmar",
	"PHL": "Philippines",
	"SWZ": "Swaziland",
	"BLR": "Belarus",
	"KEN": "Kenya",
	"LSO": "Lesotho",
	"ITA": "Italy",
	"NLD": "Netherlands",
	"MEX": "Mexico",
	"BGD": "Bangladesh",
	"AUT": "Austria",
	"ROU": "Romania",
	"CYP": "Cyprus",
	"ZMB": "Zambia",
	"MUS": "Mauritius",
	"PRI": "Puerto Rico",
	"CHL": "Chile",
	"UGA": "Uganda",
	"LVA": "Latvia",
	"CPV": "Cape Verde",
	"AGO": "Angola",
	"SGP": "Singapore",
	"MNG": "Mongolia",
	"PRT": "Portugal",
	"AFG": "Afghanistan",
	"FIN": "Finland",
	"LBN": "Lebanon",
	"TUN": "Tunisia",
	"QAT": "Qatar",
	"EGY": "Egypt",
	"PRY": "Paraguay",
	"LBR": "Liberia",
	"SAU": "Saudi Arabia",
	"MNE": "Montenegro",
	"IRN": "Iran",
	"FRA": "France",
	"MWI": "Malawi",
	"SEN": "Senegal",
	"GEO": "Georgia",
	"MLI": "Mali",
	"BLZ": "Belize",
	"BGR": "Bulgaria",
	"BFA": "Burkina Faso",
	"IND": "India",
	"MRT": "Mauritania",
	"MDA": "Moldova",
	"RUS": "Russia",
	"THA": "Thailand",
	"GHA": "Ghana",
	"EST": "Estonia",
	"HTI": "Haiti",
	"CHN": "China",
	"CHE": "Switzerland",
	"BRA": "Brazil",
	"LAO": "Laos",
	"LBY": "Libya",
	"TUR": "Turkey",
	"JOR": "Jordan",
	"KGZ": "Kyrgyzstan",
	"BRB": "Barbados",
	"PER": "Peru",
	"VEN": "Venezuela",
	"SVN": "Slovenia",
	"DEU": "Germany",
	"SUR": "Suriname",
	"SRB": "Serbia",
	"UKR": "Ukraine",
	"DOM": "Dominican Republic",
	"MKD": "Macedonia",
	"TTO": "Trinidad and Tobago",
	"TJK": "Tajikistan",
	"BEN": "Benin",
	"COL": "Colombia",
	"YEM": "Yemen",
	"ISL": "Iceland",
	"PAN": "Panama",
	"LUX": "Luxembourg",
	"BEL": "Belgium",
	"GAB": "Gabon",
	"GMB": "Gambia",
	"AUS": "Australia",
	"SLE": "Sierra Leone",
	"DNK": "Denmark",
	"ARE": "United Arab Emirates",
	"MAR": "Morocco",
	"NPL": "Nepal",
	"BIH": "Bosnia and Herzegovina",
	"HUN": "Hungary",
	"USA": "United States",
	"SYC": "Seychelles",
	"UZB": "Uzbekistan",
	"CIV": "Ivory Coast",
	"SLV": "El Salvador",
	"ESP": "Spain",
	"ZWE": "Zimbabwe",
	"KWT": "Kuwait",
	"GUY": "Guyana",
	"CMR": "Cameroon",
	"BTN": "Bhutan",
	"ARG": "Argentina",
	"GBR": "United Kingdom",
	"TWN": "Taiwan",
	"MLT": "Malta",
	"BWA": "Botswana",
	"TZA": "Tanzania",
	"HKG": "Hong Kong",
	"TCD": "Chad",
	"IDN": "Indonesia",
	"LTU": "Lithuania",
	"PAK": "Pakistan",
	"MDG": "Madagascar",
	"CAN": "Canada",
	"NZL": "New Zealand",
	"TLS": "Timor-Leste",
	"RWA": "Rwanda",
	"NAM": "Namibia",
	"GIN": "Guinea"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/data_countries.json
// module id = 587
// module chunks = 0